import { useTranslation } from '@ibk/shared-translation';
import { validateFileFormat, validateFileSize, validateImageDimensions } from '../utils/fileValidation';
export const useFileValidation = ({ acceptTypes, maxSizeKB, maxWidth, maxHeight, type }) => {
    const { t } = useTranslation();
    const validateFile = (file) => {
        const formatError = validateFileFormat(file, acceptTypes, t);
        if (formatError)
            return formatError;
        const sizeError = validateFileSize(file, maxSizeKB, t);
        if (sizeError)
            return sizeError;
        return null;
    };
    const validateFileWithDimensions = async (file) => {
        const basicError = validateFile(file);
        if (basicError)
            return basicError;
        if (type === 'image') {
            const dimensionError = await validateImageDimensions(file, maxWidth, maxHeight, t);
            if (dimensionError)
                return dimensionError;
        }
        return null;
    };
    return {
        validateFile,
        validateFileWithDimensions,
    };
};
